import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnalyticsDirectivesModule } from '@analytics/events';
import { CoreJssProxyModule } from '@core/jss-proxy';
import { StructuredDataModule } from '@core/structured-data';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GenericErrorModalModule } from '@innogy/common-ui-modals';

import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import {
  NgbAccordionModule,
  NgbCollapseModule,
} from '@ng-bootstrap/ng-bootstrap';
import {
  CSCaptureDirective,
  CSMaskDirective,
} from '@legacy/utils-contentsquare';
import { DeployUrlPipe } from '@innogy/utils/environment';
import {
  ButtonComponent,
  CardComponent,
  ImageComponent,
  ListItemComponent,
  MediaCardComponent,
  MediaSectionComponent,
  PartialJumbotronComponent,
  StructuredContentComponent,
} from '@legacy/common-ui-partials';
import {
  ExperienceEditorComponent,
  ExperienceEditorLiveDirective,
  ExperienceEditorPreviewDirective,
  ShowInExperienceEditorDirective,
} from '@core/experience-editor-components';
import { BackgroundDirective } from '@legacy/common-ui-shared';
import { ScIconPipe } from '@core/jss-utils';

import { LegacyMijnAccordionContainerComponent } from './accordion/accordion-container.component';
import { AnchorComponent } from './anchor/anchor.component';
import { basicContentComponents } from './basic-content';
import { BasicContentComponent } from './basic-content/basic-content.component';
import { BasicContentVariantMediaCardComponent } from './basic-content/variants/basic-content-variant-media-card/basic-content-variant-media-card.component';
import { BasicContentVariantMediaSectionComponent } from './basic-content/variants/basic-content-variant-media-section/basic-content-variant-media-section.component';
import { CardContentBlockComponent } from './card-content-block/card-content-block.component';
import { ComposablesModule } from './composables/composables.module';
import { EqualHeightComponent } from './equal-height/equal-height.component';
import { FunctionalErrorComponent } from './functional-error/functional-error.component';
import { HorizontalLinksListComponent } from './horizontal-links-list/horizontal-links-list.component';
import { IconListItemComponent } from './icon-list/icon-list-item/icon-list-item.component';
import { IconListComponent } from './icon-list/icon-list.component';
import { ImageWrapperComponent } from './image-wrapper/image-wrapper.component';
import { InfoCardContainerComponent } from './info-card/info-card-container.component';
import { JumbotronContainerComponent } from './jumbotron/jumbotron-container.component';
import { listComponents } from './list';
import { ListContainerComponent } from './list/list-container.component';
import { MultipleLinksListContainerComponent } from './multiple-links-list/multiple-links-list-container/multiple-links-list-container.component';
import { MultipleLinksListComponent } from './multiple-links-list/multiple-links-list.component';
import { ReceiptBreakdownRowComponent } from './receipt/receipt-breakdown-row/receipt-breakdown-row.component';
import { ReceiptBreakdownDirective } from './receipt/receipt-breakdown.directive';
import { ReceiptConclusionDirective } from './receipt/receipt-conclusion.directive';
import { ReceiptComponent } from './receipt/receipt.component';
import { RichTextComponent } from './rich-text/rich-text.component';
import { StickyWrapperComponent } from './sticky-wrapper/sticky-wrapper.component';
import { TimerWidgetWrapperComponent } from './timer/timer-widget/timer-widget-wrapper/timer-widget-wrapper.component';
import { TimerWidgetComponent } from './timer/timer-widget/timer-widget.component';
import { TimerWrapperComponent } from './timer/timer-wrapper/timer-wrapper.component';
import { TimerComponent } from './timer/timer.component';
import { VideoContainerComponent } from './video/video-container/video-container.component';
import { VideoFallbackComponent } from './video/video-fallback/video-fallback.component';
import { VideoComponent } from './video/video.component';

const exportedComponents = [
  VideoContainerComponent,
  MultipleLinksListContainerComponent,
  HorizontalLinksListComponent,
  LegacyMijnAccordionContainerComponent,
  RichTextComponent,
  EqualHeightComponent,
  AnchorComponent,
  InfoCardContainerComponent,
  JumbotronContainerComponent,
  BasicContentComponent,
  ListContainerComponent,
  FunctionalErrorComponent,
  ReceiptComponent,
  ReceiptBreakdownDirective,
  ReceiptConclusionDirective,
  ReceiptBreakdownRowComponent,
  StickyWrapperComponent,
  CardContentBlockComponent,
  TimerComponent,
  TimerWrapperComponent,
  TimerWidgetComponent,
  TimerWidgetWrapperComponent,
];

@NgModule({
  imports: [
    CommonModule,
    CoreJssProxyModule,
    GenericErrorModalModule,
    CommonUiUtilityComponentsModule,
    AnalyticsDirectivesModule,
    NgbCollapseModule,
    NgbAccordionModule,
    FontAwesomeModule,
    StructuredDataModule,
    ComposablesModule,
    CSCaptureDirective,
    CSMaskDirective,
    DeployUrlPipe,
    CardComponent,
    ImageComponent,
    ButtonComponent,
    StructuredContentComponent,
    MediaCardComponent,
    MediaSectionComponent,
    ExperienceEditorComponent,
    ExperienceEditorPreviewDirective,
    ExperienceEditorLiveDirective,
    PartialJumbotronComponent,
    BackgroundDirective,
    ListItemComponent,
    ScIconPipe,
    ShowInExperienceEditorDirective,
    ...exportedComponents,
    ...basicContentComponents,
    ...listComponents,
    VideoComponent,
    MultipleLinksListComponent,
    IconListComponent,
    IconListItemComponent,
    ImageWrapperComponent,
    ListContainerComponent,
    BasicContentVariantMediaSectionComponent,
    BasicContentVariantMediaCardComponent,
    VideoFallbackComponent,
  ],
  exports: [...exportedComponents],
})
export class CommonUiCommonRenderingsModule {}
